export default "__VITE_ASSET__Dpngk4Fr__"